import * as React from 'react'
import WarningIcon from '@mui/icons-material/WarningRounded'
import { PPDialog } from 'components/PPDialog'
import Logo from 'components/PPLogo'

import styles from './MaintenanceView.pcss'

export function MaintenanceView(props: {
  title: string | React.ReactElement<any> | number | string,
  subtitle: string | React.ReactElement<any> | number | string,
  action?: React.ReactElement<any> | number | string
}) {
  return (
    <PPDialog
      open
      dismissible={false}
      className={styles.dialog}
      title={
        <span className={styles.title}>
          <WarningIcon className={styles.icon} />
          {props.title}
        </span>
      }
    >
      <div className={styles.content}>
        <a href="https://postplanner.com">
          <Logo key="logo" className={styles.logo} />
        </a>
        <p className={styles.message}>{props.subtitle}</p>
        {
          props.action && (
            <div className={styles.action}>
              {props.action}
            </div>
          )
        }
      </div>
    </PPDialog>
  )
}
